/**
 * Runtime parameters. This file has no alias: import it relatively, with as many `../` as levels
 * below `src/`. It is the only place that reads `import.meta.env`.
 */
type Parameters = {
	readonly api: {
		readonly host: string;
	};
	readonly environment: string;
	readonly debug: boolean;
	readonly pwa: {
		readonly serviceWorkerEnabled: boolean;
	};
};

const environment: string = import.meta.env.MODE;

const parameters: Parameters = {
	api: {
		host: import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:3000',
	},
	environment,
	debug: environment === 'development',
	pwa: {
		serviceWorkerEnabled: environment === 'production',
	},
};

export default Object.freeze(parameters);
